/* ==========================================================================
   Picked for you: swaps the homepage product row for products related to what
   this visitor searched, viewed or browsed. Reads the history that
   snippets/interest-tracker.liquid keeps in localStorage (this browser only).
   If there is no history, or nothing matches, the fallback row stays as is.
   ========================================================================== */
(function () {
  "use strict";

  var KEY = "mk_interest_v1";
  var RESULTS_SECTION = "picked-for-you-results";
  var MIN_PRODUCTS = 2;
  var MAX_TRIES = 3;

  function root() {
    var r = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return r || "/";
  }

  function readHistory(days) {
    try {
      var list = JSON.parse(localStorage.getItem(KEY) || "[]");
      if (!Array.isArray(list)) return [];
      var cutoff = Date.now() - days * 864e5;
      return list.filter(function (e) { return e && e.t > cutoff && (e.q || e.id || e.h); });
    } catch (e) { return []; }
  }

  function clearHistory() {
    try { localStorage.removeItem(KEY); } catch (e) {}
  }

  function resultsUrl(ev) {
    var sid = "section_id=" + RESULTS_SECTION;
    if (ev.k === "search") {
      return root() + "search?type=product&options%5Bprefix%5D=last&q=" + encodeURIComponent(ev.q) + "&" + sid;
    }
    if (ev.k === "collection") {
      return root() + "collections/" + encodeURIComponent(ev.h) + "?" + sid;
    }
    if (ev.k === "product") {
      return root() + "recommendations/products?intent=related&limit=12&product_id=" + encodeURIComponent(ev.id) + "&" + sid;
    }
    return null;
  }

  function shorten(text, max) {
    text = String(text || "").trim();
    if (text.length <= max) return text;
    var cut = text.slice(0, max);
    var sp = cut.lastIndexOf(" ");
    return (sp > max * 0.6 ? cut.slice(0, sp) : cut).replace(/[\s,.;:-]+$/, "") + "…";
  }

  function copyFor(ev, labels) {
    if (ev.k === "search") {
      return {
        heading: labels.search + " “" + shorten(ev.q, 40) + "”",
        link: root() + "search?type=product&options%5Bprefix%5D=last&q=" + encodeURIComponent(ev.q),
        linkText: "See all results"
      };
    }
    if (ev.k === "product") {
      return { heading: labels.product + " " + shorten(ev.title, 48), link: ev.url, linkText: "View product" };
    }
    return { heading: labels.collection + " " + shorten(ev.title, 48), link: ev.url, linkText: "View all products" };
  }

  function fetchCards(ev, count) {
    var url = resultsUrl(ev);
    if (!url) return Promise.resolve([]);
    return fetch(url, { credentials: "same-origin" })
      .then(function (r) { return r.ok ? r.text() : ""; })
      .then(function (html) {
        if (!html) return [];
        var doc = new DOMParser().parseFromString(html, "text/html");
        return Array.prototype.slice.call(doc.querySelectorAll(".picked-results > .product-card"), 0, count);
      })
      .catch(function () { return []; });
  }

  function init(section) {
    if (section.dataset.enabled !== "true" || section.dataset.design === "true") return;

    var count = parseInt(section.dataset.count, 10) || 8;
    var days = parseInt(section.dataset.days, 10) || 30;
    var history = readHistory(days);
    if (!history.length) return;

    var grid = section.querySelector("[data-picked-grid]");
    var heading = section.querySelector("[data-picked-heading]");
    var eyebrow = section.querySelector("[data-picked-eyebrow]");
    var link = section.querySelector("[data-picked-link]");
    var linkText = section.querySelector("[data-picked-link-text]");
    var reset = section.querySelector("[data-picked-reset]");
    if (!grid || !heading) return;

    var original = {
      grid: grid.innerHTML,
      heading: heading.textContent,
      eyebrow: eyebrow ? eyebrow.textContent : "",
      link: link ? link.getAttribute("href") : "",
      linkText: linkText ? linkText.textContent : ""
    };
    var labels = {
      search: section.dataset.labelSearch || "Because you searched",
      product: section.dataset.labelProduct || "Related to",
      collection: section.dataset.labelCollection || "More from"
    };

    function apply(ev, cards) {
      var c = copyFor(ev, labels);
      grid.innerHTML = "";
      cards.forEach(function (card) { grid.appendChild(document.importNode(card, true)); });
      grid.classList.remove("picked-in"); void grid.offsetWidth; grid.classList.add("picked-in");
      heading.textContent = c.heading;
      if (eyebrow && section.dataset.eyebrow) eyebrow.textContent = section.dataset.eyebrow;
      if (link && c.link) link.setAttribute("href", c.link);
      if (linkText) linkText.textContent = c.linkText;
      if (reset) reset.hidden = false;
      section.setAttribute("data-picked-source", ev.k);
    }

    function restore() {
      grid.innerHTML = original.grid;
      heading.textContent = original.heading;
      if (eyebrow) eyebrow.textContent = original.eyebrow;
      if (link) link.setAttribute("href", original.link);
      if (linkText) linkText.textContent = original.linkText;
      if (reset) reset.hidden = true;
      section.removeAttribute("data-picked-source");
    }

    if (reset) {
      reset.addEventListener("click", function () { clearHistory(); restore(); heading.setAttribute("tabindex", "-1"); heading.focus(); });
    }

    /* Try the newest activity first; fall through to older ones if it finds too little. */
    var tries = history.slice(0, MAX_TRIES);
    (function next(i) {
      if (i >= tries.length) return;
      fetchCards(tries[i], count).then(function (cards) {
        if (cards.length >= MIN_PRODUCTS) apply(tries[i], cards);
        else next(i + 1);
      });
    })(0);
  }

  function start() {
    document.querySelectorAll("[data-picked]").forEach(init);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();
})();
